import { Check, ArrowUpRight } from "lucide-react";
import { WHATSAPP_URL } from "../i18n";
import { Reveal } from "./Reveal";

export const PainSection = ({ data, image, imageAlt, id, testId, reverse = false }) => {
  return (
    <section id={id} data-testid={testId} className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className={`grid items-center gap-12 lg:grid-cols-2 ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
          <Reveal>
            <div className="group relative overflow-hidden rounded-3xl border border-slate-800">
              <img
                src={image}
                alt={imageAlt}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070B11] via-[#070B11]/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <p className="font-mono2 text-[10px] uppercase tracking-[0.28em] text-red-400">
                  {data.painLabel}
                </p>
                <p className="font-display mt-3 text-xl font-bold leading-snug text-slate-100 sm:text-2xl">
                  {data.pain}
                </p>
              </div>
            </div>
          </Reveal>
          <div>
            <Reveal>
              <p className="font-mono2 text-xs uppercase tracking-[0.28em] text-emerald-400">{data.kicker}</p>
              <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl">
                {data.title}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="glass mt-8 rounded-2xl p-7">
                <p className="font-mono2 text-[10px] uppercase tracking-[0.28em] text-emerald-400">
                  {data.solLabel}
                </p>
                <h3 className="font-display mt-3 text-2xl font-bold tracking-tight text-gradient">
                  {data.solTitle}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-400 sm:text-base">{data.sol}</p>
                <ul className="mt-6 space-y-3">
                  {data.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm text-slate-300">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500/15">
                        <Check className="h-3 w-3 text-emerald-400" />
                      </span>
                      {b}
                    </li>
                  ))}
                </ul>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`${testId}-cta`}
                  className="mt-7 inline-flex items-center gap-2 rounded-full border border-emerald-500/40 px-5 py-2.5 text-sm font-semibold text-emerald-300 transition-all hover:bg-emerald-500/10 hover:scale-[1.03]"
                >
                  {data.cta}
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
